import { createContext, useContext, useRef, useState } from "react";

const NavContext = createContext();

export function NavProvider({ children }) {
  const [activeSection, setActiveSection] = useState("home");
  const manualClick = useRef(false);

  return (
    <NavContext.Provider value={{ activeSection, setActiveSection, manualClick }}>
      {children}
    </NavContext.Provider>
  );
}

export function useNav() {
  return useContext(NavContext);
}
